import {
  IReservationSlot,
  IReservationSlots,
} from '@/interfaces/IReservationSlots';
import { ITableReservationAvailability } from './table-availability';

export function groupReservationSlots(payload: IReservationSlots) {
  return payload.shifts.map((shift) => ({
    shift,
    slots: payload.slots.filter((slot) => {
      if (slot.shiftId !== shift.id) return false;
      const from = shift.from.slice(0, 5);
      const to = shift.to.slice(0, 5);
      return to < from
        ? slot.label >= from || slot.label < to
        : slot.label >= from && slot.label < to;
    }),
  }));
}

export function getReservationSlotState(
  slot: IReservationSlot,
  options: {
    force?: boolean;
    explicitTableIds?: readonly number[];
    tables?: readonly ITableReservationAvailability[];
  } = {}
) {
  const explicit = options.explicitTableIds ?? [];
  const explicitAvailable =
    explicit.length > 0 &&
    explicit.every((id) =>
      options.tables?.some((table) => table.table.id === id && table.selectable)
    );
  const forced =
    !slot.available &&
    (slot.reason === 'no_table'
      ? explicitAvailable
      : !!options.force && slot.forceable);
  return {
    selectable: slot.available || forced,
    forced,
    canForce:
      slot.forceable &&
      (slot.reason === 'pacing' ||
        slot.reason === 'window_full' ||
        slot.reason === 'closed'),
  };
}

export function nearbyReservationSlots(
  slots: readonly IReservationSlot[],
  wanted: string,
  withinMin = 90,
  limit = 4
): IReservationSlot[] {
  const target = new Date(wanted).getTime();
  if (!Number.isFinite(target)) return [];
  return slots
    .filter(
      (slot) =>
        slot.available &&
        Math.abs(new Date(slot.startsAt).getTime() - target) <=
          withinMin * 60000
    )
    .slice()
    .sort(
      (a, b) =>
        Math.abs(new Date(a.startsAt).getTime() - target) -
          Math.abs(new Date(b.startsAt).getTime() - target) ||
        a.startsAt.localeCompare(b.startsAt)
    )
    .slice(0, Math.max(0, limit));
}
